import { render, staticRenderFns } from "./DxDetailTabDriver.vue?vue&type=template&id=39cb21ba&"
import script from "./DxDetailTabDriver.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports